<template>
  <section class="relative bg-white">
    <div class="container mx-auto mb-16 md:mb-0 py-4">
      <div class="w-full md:w-1/2 md:pr-4">
        <div class="max-w-sm mx-auto">
          <div class="mb-6 text-center">
            <a
              class="inline-block mb-6"
              href="#"
            >
              <img
                class="h-16"
                src="../assets/Images/djuliImageSquared.png"
                alt=""
              >
            </a>
            <h3 class="mb-4 text-2xl md:text-3xl font-bold">
              Welcome to Djuli
            </h3>
            <p class="text-lg text-coolGray-500 font-medium">
              Create your account with us now
            </p>
          </div>
          <form @submit.prevent="submitSignup">
            <div class="mb-6">
              <label
                class="block mb-2 text-coolGray-800 font-medium"
                for="fullname"
              >Full Name*</label>
              <input
                id="fullname"
                v-model="displayName"
                class="
								`appearance-none
								block
								w-full
								p-3
								leading-5
								text-coolGray-900
								border border-coolGray-200
								rounded-lg
								shadow-md
								placeholder-coolGray-400
								focus:outline-none
								focus:ring-2
								focus:ring-green-500
								focus:ring-opacity-50"
                type="name"
                placeholder="Enter your name"
                required
              >
            </div>
            <div class="mb-6">
              <label
                class="block mb-2 text-coolGray-800 font-medium"
                for="username"
              >Username*</label>
              <input
                id="username"
                v-model="username"
                class="
								appearance-none
								block
								w-full
								p-3
								leading-5
								text-coolGray-900
								border border-coolGray-200
								rounded-lg
								shadow-md
								placeholder-coolGray-400
								focus:outline-none
								focus:ring-2
								focus:ring-green-500
								focus:ring-opacity-50"
                type="name"
                placeholder="Enter username"
                required
              >
              `
            </div>
            <div class="mb-6">
              <label
                class="block mb-2 text-coolGray-800 font-medium"
                for="email"
              >Email*</label>
              <input
                id="email"
                v-model="email"
                class="
								appearance-none
								block
								w-full
								p-3
								leading-5
								text-coolGray-900
								border border-coolGray-200
								rounded-lg
								shadow-md
								placeholder-coolGray-400
								focus:outline-none
								focus:ring-2
								focus:ring-green-500
								focus:ring-opacity-50"
                type="name"
                placeholder="example@djuli.no."
                required
              >
            </div>
            <div class="mb-6">
              <label
                class="block mb-2 text-coolGray-800 font-medium"
                for="phone"
              >Phone</label>
              <input
                id="phone"
                v-model="phone"
                class="
								appearance-none
								block
								w-full
								p-3
								leading-5
								text-coolGray-900
								border border-coolGray-200
								rounded-lg
								shadow-md
								placeholder-coolGray-400
								focus:outline-none
								focus:ring-2
								focus:ring-green-500
								focus:ring-opacity-50"
                type="name"
                placeholder="Enter your Phone"
              >
            </div>
            <div class="mb-6">
              <label
                class="block mb-2 text-coolGray-800 font-medium"
                for="company"
              >Company</label>
              <input
                id="company"
                v-model="company"
                class="
								appearance-none
								block
								w-full
								p-3
								leading-5
								text-coolGray-900
								border border-coolGray-200
								rounded-lg
								shadow-md
								placeholder-coolGray-400
								focus:outline-none
								focus:ring-2
								focus:ring-green-500
								focus:ring-opacity-50"
                type="name"
                placeholder="Enter your company"
              >
            </div>

            <div class="mb-6">
              <label
                class="block mb-2 text-coolGray-800 font-medium"
                for="title"
              >Title</label>
              <input
                id="title"
                v-model="title"
                class="
								appearance-none
								block
								w-full
								p-3
								leading-5
								text-coolGray-900
								border border-coolGray-200
								rounded-lg
								shadow-md
								placeholder-coolGray-400
								focus:outline-none
								focus:ring-2
								focus:ring-green-500
								focus:ring-opacity-50"
                type="name"
                placeholder="Enter your title"
              >
            </div>

            <div class="mb-6">
              <label
                class="block mb-2 text-coolGray-800 font-medium"
                for="country"
              >Country</label>
              <input
                id="country"
                v-model="country"
                class="
								appearance-none
								block
								w-full
								p-3
								leading-5
								text-coolGray-900
								border border-coolGray-200
								rounded-lg
								shadow-md
								placeholder-coolGray-400
								focus:outline-none
								focus:ring-2
								focus:ring-green-500
								focus:ring-opacity-50"
                type="name"
                placeholder="Enter your country"
              >
            </div>
            <div class="mb-4">
              <label
                class="block mb-2 text-coolGray-800 font-medium"
                for="password"
              >Password*</label>
              <input
                id="password"
                v-model="password"
                class="
								appearance-none
								block
								w-full
								p-3
								leading-5
								text-coolGray-900
								border border-coolGray-200
								rounded-lg
								shadow-md
								placeholder-coolGray-400
								focus:outline-none
								focus:ring-2
								focus:ring-green-500
								focus:ring-opacity-50"
                type="password"
                placeholder="************"
                required
              >
            </div>
            <div class="flex flex-wrap items-center justify-between mb-6">
              <div class="w-full">
                <label class="relative inline-flex items-center">
                  <span class="text-xs text-coolGray-800 font-medium">
                    By signing up, you agree to our
                    <router-link
                      to="termsandconditions"
                      class="text-green-500 hover:text-green-600"
                    >Terms and
                      Conditions</router-link>
                    and
                    <router-link
                      to="termsandconditions"
                      class="text-green-500 hover:text-green-600"
                    >Privacy
                      Policy</router-link></span>
                </label>
              </div>
            </div>
            <div v-if="$route.params.subscription === 'freemium'">
              Haven't decided yet on subscription?
              <div class="flex flex-wrap items-center space-x-3 mb-6">
                <input
                  id="checkbox"
                  v-model="opted_for_freemium"
                  type="checkbox"
                  class="w-10"
                >
                <span class="text-coolGray-800 font-medium text-sm">
                  Consider using the Free plan to enjoy benefits.
                </span>
              </div>
            </div>
            <button
              type="submit"
              class="inline-block py-3 px-7 mb-4 w-full text-base text-green-50 font-medium text-center leading-6 bg-green-500 hover:bg-green-600 focus:ring-2 focus:ring-green-500 focus:ring-opacity-50 rounded-md shadow-sm"
            >
              Sign Up
            </button>
            <p class="text-center space-x-2">
              <span class="text-xs font-medium">Already have an account?</span>
              <router-link
                to="/"
                class="
								inline-block
								text-xs
								font-medium
								text-green-500
								hover:text-green-600 hover:underline
								"
              >
                Sign In
              </router-link>
            </p>
          </form>
        </div>
      </div>
    </div>
    <div class="md:absolute md:top-0 md:right-0 md:w-1/2 md:h-full md:pl-4">
      <div
        class="
				flex
				items-center
				justify-center
				h-full
				px-8
				py-14
				bg-coolGray-50"
      >
        <div class="md:max-w-xl mx-auto text-center">
          <span
            class="
						relative
						z-10
						inline-block
						py-px
						px-2
						mb-4
						text-xs
						leading-5
						text-green-500
						bg-green-100
						font-medium
						uppercase
						rounded-full
						shadow-sm"
          >Quotes
          </span>
          <div class="relative mb-16">
            <img
              class="absolute -top-10 left-0 2xl:-left-12"
              src="flex-ui-assets/elements/sign-up/quotes-top.svg"
              alt=""
            >
            <img
              class="absolute -bottom-16 right-0"
              src="flex-ui-assets/elements/sign-up/quotes-bottom.svg"
              alt=""
            >
            <h3
              class="
							relative
							text-2xl
							md:text-3xl
							leading-tight
							font-medium
							text-coolGray-800"
            >
              Automated data analysis leaves <i>less</i> punching in of numbers, and <i>more</i> focus on the actual task
              generating the data.
            </h3>
          </div>
          <div class="relative text-center">
            <img
              class="w-25 h-25 mb-6 mx-auto rounded-full"
              src="../assets/Images/sindre.jpg"
              alt=""
            >
            <h4 class="mb-2 text-lg text-coolGray-800 font-semibold">
              Sindre Søpstad
            </h4>
            <span class="block mb-8 text-lg text-coolGray-400">Lead System Architect &amp; Zimmer and Peacock AS</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
	name: 'Register',
	metaInfo: {
		title: 'Create Account – Djuli',
		meta: [
			{ name: 'description', content: 'Create your free Djuli account and start analysing sensor data in the cloud today.' },
			{ property: 'og:title', content: 'Create Account – Djuli' },
			{ property: 'og:url', content: 'https://dju.li/register' },
			{ property: 'og:type', content: 'website' },
		],
	},
	data() {
		return {
			email: '',
			password: '',
			confirmPassword: '',
			displayName: '',
			firstName: '',
			lastName: '',
			phone:'',
			company: '',
			title:'',
			country: '',
			username: '',
			leadSource:'Djuli',
			checkedNewsLetter: false,
			opted_for_freemium: false,
			responseStatus:null
		};
	},
	computed: mapGetters(['getLastErrorMiddleware']),
	mounted() {
		this.opted_for_freemium = false;
		document.dispatchEvent(new Event('render-event'));
	},
	methods: {
		...mapActions(['signupMiddlewareAuth', 'fetchTokenAuth', 'addMessageTerminalSection']),

		async submitSignup() {
			let zohoAuthSuccess = false;
			let signupSuccess = false;
			this.firstName = this.extractName(this.displayName).FirstName;
			this.lastName = this.extractName(this.displayName).LastName;

			let zohoAccessToken = sessionStorage.getItem('zohoAccessToken') !== 'undefined' && sessionStorage.getItem('zohoAccessToken') !== null ? sessionStorage.getItem('zohoAccessToken') : null;
			const zohoTokenExpirationTime = !isNaN(sessionStorage.getItem('zohoTokenExpirationTime')) && sessionStorage.getItem('zohoTokenExpirationTime') !== null ? sessionStorage.getItem('zohoTokenExpirationTime') : null;

			try {
				//Fetch zoho access token if not active
				if(zohoAccessToken === null || zohoTokenExpirationTime === null || zohoTokenExpirationTime <= Date.now()){
					zohoAuthSuccess = await this.fetchTokenAuth({
							zohoAccessToken: zohoAccessToken,
							zohoTokenExpirationTime: zohoTokenExpirationTime,
						})
				}
				else {
					zohoAuthSuccess = true;
				}
				//Request for user registration and creation in Zoho
				if (zohoAuthSuccess && sessionStorage.getItem('zohoAccessToken') !== 'undefined' && sessionStorage.getItem('zohoAccessToken')!== null && !isNaN(sessionStorage.getItem('zohoTokenExpirationTime'))){
					zohoAccessToken = sessionStorage.getItem('zohoAccessToken');
					this.responseStatus = await this.signupMiddlewareAuth({  // returns true if success
							email: this.email,
							password: this.password,
							confirmPassword: this.password,
							displayName: this.displayName,
							firstName: this.firstName,
							lastName: this.lastName,
							username: this.username,
							phone:this.phone,
							company: this.company,
							title:this.title,
							leadSource: this.leadSource,
							country: this.country,
							termsAccepted: true,
							zohoAccessToken: zohoAccessToken,
							privacyPolicyAccepted: true,
							receiveNewsLetters: this.checkedNewsLetter,
							opted_for_freemium: this.opted_for_freemium,
						});
						signupSuccess = this.responseStatus?.success;
				}
				if (!signupSuccess) {  // If it is unable to create in Djuli and unble to register in Zoho CRM
					await this.$alert(
						this.responseStatus?.code === 409 ? 'You can reset your password in the login page' :'Please try in a few seconds',
						this.responseStatus?.message || 'Error when trying to create the account',
						'warning',
						{
							confirmButtonText: 'Got it!',
						}
					);
					return;
				}
				await this.$alert(
					`Welcome ${this.displayName}. ${this.responseStatus.message}`,
					'Success',
					'success'
				);
				this.$router.replace('/login');
			} catch (error) {
				await this.$alert(
					'Something went wrong, Please try again later',
					'Error',
					'error'
				);
			}
		},
		extractName(fullName) {
			// Remove leading/trailing whitespace and split the full name into an array of words
			const nameArray = fullName.trim().replace(/\s+/g, ' ').split(' ');
			// Extract the first and last name from the name array
			if(nameArray.length > 2){
				this.firstName = nameArray[0] + ' ' + nameArray[1];
			}
			if(nameArray.length < 3){
				this.firstName = nameArray[0]
			}
			this.lastName = nameArray[nameArray.length - 1];

			return {
				FirstName: this.firstName,
				LastName: this.lastName
			};
		},
		emailValidation(value) {
			return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value);
		},
		passwordValiation(value) {
			return (
				value.length >= 8 &&
				/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.* )(?=.*[^a-zA-Z0-9]).{8,}$/.test(
					value
				)
			);
		},
	},
};
</script>
<style lang="scss" scoped>
.djuliLogo {
	width: 30vw;
	position: fixed;
	left: 35vw;
	margin: auto;
	opacity: 0.5;
	z-index: -100;
}

.form-group {
	margin-top: 1rem !important;
}

h3 {
	margin-top: 1rem !important;
}

.login-container {
	width: 18vw;
}

.active {
	opacity: 0.3;
}

.loader {
	position: absolute;
	left: 46%;
	top: 35%;
}

.sign-btn {
	display: inline-flex;
	position: relative;
}

.btn-margin {
	margin-left: 0.2rem;
	font-size: 16px;
	font-weight: 600;
	text-decoration: none;
}

.float-label {
	backdrop-filter: blur(2px);
	font-size: 0.8rem;
}

.background_pattern {
	background-image: url("../assets/SVG/pattern-white.svg?inline");
	background-position: center;
}
</style>
